var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"switch"},[_c('a-switch',{attrs:{"checked":_vm.value,"disabled":_vm.disabled},on:{"change":_vm.onChange}}),_c('span',{staticClass:"switch_text",domProps:{"textContent":_vm._s(_vm.switchText)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }